import { Module } from 'vuex';
import { State as StateInterface } from '@/store/index';

import state, { CouponStateInterface } from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const CouponModule: Module<CouponStateInterface, StateInterface> = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default CouponModule;
